export default function createQueryStringFromArray(array = [], param="") {
    let queryString = "?"
    array.map((x, index) => {
        if(index) queryString += "&"
        return queryString += param +"="+ x 
    })
     return queryString
}